import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustom0767ExitRight({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="currentColor" fillRule="nonzero">
        <path d="M4.25 16V4c0-.827.673-1.5 1.5-1.5h8.5c.827 0 1.5.673 1.5 1.5v4a.5.5 0 01-1 0V4a.5.5 0 00-.5-.5h-8.5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h8.5a.5.5 0 00.5-.5v-4a.5.5 0 011 0v4c0 .827-.673 1.5-1.5 1.5h-8.5c-.827 0-1.5-.673-1.5-1.5z" />
        <path d="M19.717 10.353a.5.5 0 000-.707l-2-2a.5.5 0 00-.707.707L18.156 9.5H9a.5.5 0 000 1h9.156l-1.146 1.147a.497.497 0 000 .706.5.5 0 00.707 0l2-2z" />
      </g>
    </svg>
  );
}
export default SvgIconCustom0767ExitRight;
